// extracted by mini-css-extract-plugin
export var checkbox = "_5b-0";
export var circle = "_5b-3";
export var horizontalContainer = "_5b-7";
export var sm = "_5b-5";
export var switch0 = "_5b-2";
export var switchDisabled = "_5b-8";
export var switchEnabled = "_5b-1";
export var textSwitchContainer = "_5b-9";
export var textSwitchOption = "_5b-a";
export var textSwitchOptionSelected = "_5b-b";
export var verticalContainer = "_5b-6";
export var xs = "_5b-4";